var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayThunderstorm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "136px",
    height: "155px",
    viewBox: "0 0 136 155",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day - thunderstorm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.3617045%",
    y1: "72.8710337%",
    x2: "63.6421593%",
    y2: "39.9796521%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "72.5161778%",
    y1: "64.9090909%",
    x2: "8.66000803%",
    y2: "22.6545455%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "day---thunderstorm",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EFCC00",
    fillRule: "nonzero",
    cx: 84.5,
    cy: 49.569191,
    r: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,0.0691909979 L84,11.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,88.069191 L84,99.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,50.069191 L45,50.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,50.069191 L134,50.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,14.069191 L57,22.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,77.069191 L120,85.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,85.069191 L57,77.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,22.069191 L120,14.069191",
    id: "Path",
    stroke: "#EFCC00",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6759917,34.069191 C59.8900952,34.0365338 74.7864611,42.957473 82.3604414,57.2361141 C94.8397967,49.9691362 110.55339,51.270247 121.656555,60.4898956 C132.75972,69.7095441 136.871287,84.8704976 131.938648,98.4039833 C127.006009,111.937469 114.08701,120.941115 99.6311764,120.920048 L43.6759917,121.069191 C19.5544075,121.069191 0,101.593598 0,77.5692359 C0,53.5448741 19.5544075,34.069191 43.6759917,34.069191 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    transform: "translate(99.376091, 87.169323) rotate(-74.390000) translate(-99.376091, -87.169323) ",
    cx: 99.3760914,
    cy: 87.1693226,
    rx: 34.1705349,
    ry: 34.2478481
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EFCC00",
    fillRule: "nonzero",
    points: "67.3902041 100.069191 62 130.550412 72.7804082 130.550412 67.3902041 153.069191 93 121.269191 80.8783673 121.269191 91.6587755 100.069191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,142.769191 C57,147.905439 52.7467051,152.069191 47.5,152.069191 C42.2532949,152.069191 38,147.905439 38,142.769191 C38,134.619191 45.6612903,127.069191 47.5,127.069191 C49.3387097,127.069191 57,134.569191 57,142.769191 Z",
    id: "Path",
    fill: "#0BAEFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayThunderstorm);
export default __webpack_public_path__ + "static/media/day-thunderstorm.c1e5aabc.svg";
export { ForwardRef as ReactComponent };